import React, {useState} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {createRefetchContainer, graphql} from 'react-relay';
import {getSprintRow} from '../rows/SprintRow';
import TimeRegBaseLevelWrapper from './TimeRegBaseLevelWrapper';
import {useGenericReportContext} from '../../../saved-report/GenericReportContext';

const TimeRegSprintRelayWrapper = ({
	relay,
	tableHeader,
	groupings,
	searchQuery,
	viewer,
	intl,
	groupIndex,
	enabledColumns,
	nextLevelProps,
	currency,
	customFieldDefinitions,
	customFieldKeys,
	pageSize,
}) => {
	const {reportId, sharedId} = useGenericReportContext();

	const sprints = viewer.reportData.sprints.edges.filter(sprint => sprint.node.timeRegTotals.totalTimeRegistered > 0);
	const hasNextPage = viewer.reportData.sprints.pageInfo.hasNextPage && sprints?.length >= pageSize;
	const [modalTasksFetching, setModalTasksFetching] = useState(false);

	const dataRows = sprints.map(sprint => {
		return {
			...sprint.node,
		};
	});

	const data = {rows: dataRows};

	const fetchMore = () => {
		if (!modalTasksFetching) {
			const refetchObject = {};
			setModalTasksFetching(true);
			refetchObject.pageSize = sprints.length + pageSize;
			relay.refetch(refetchObject, null, () => setModalTasksFetching(false));
		}
	};

	const sprintRows = () => {
		return getSprintRow(
			data,
			intl,
			groupIndex,
			searchQuery,
			groupings,
			enabledColumns,
			hasNextPage,
			fetchMore,
			nextLevelProps,
			currency,
			reportId,
			sharedId,
			customFieldDefinitions,
			customFieldKeys
		);
	};

	return groupIndex === 1 ? (
		<TimeRegBaseLevelWrapper
			tableHeader={tableHeader}
			intl={intl}
			enabledColumns={enabledColumns}
			getRows={sprintRows}
			currentLength={sprints.length}
			hasNextPage={viewer.reportData.sprints.pageInfo.hasNextPage}
			refetch={relay.refetch}
			customFieldDefinitions={customFieldDefinitions}
			pageSize={pageSize}
		/>
	) : (
		sprintRows()
	);
};

const TimeRegSprintRelayWrapperQuery = graphql`
	query TimeRegSprintRelayWrapper_Query(
		$searchQuery: TaskSearchQueryType
		$pageSize: Int
		$reportId: String
		$sharedId: String
	) {
		viewer {
			actualPersonId
			component(name: "time_reg_sprint_relay_wrapper_v2")
			...TimeRegSprintRelayWrapper_viewer
				@arguments(searchQuery: $searchQuery, pageSize: $pageSize, reportId: $reportId, sharedId: $sharedId)
		}
	}
`;
export {TimeRegSprintRelayWrapperQuery};

export default injectIntl(
	withRouter(
		createRefetchContainer(
			TimeRegSprintRelayWrapper,
			{
				viewer: graphql`
					fragment TimeRegSprintRelayWrapper_viewer on Viewer
					@argumentDefinitions(
						searchQuery: {type: "TaskSearchQueryType"}
						pageSize: {type: "Int"}
						reportId: {type: "String"}
						sharedId: {type: "String"}
					) {
						reportData(id: $reportId, sharedId: $sharedId) {
							sprints(first: $pageSize, searchQuery: $searchQuery)
								@connection(key: "TimeRegReport_sprints", filters: ["searchQuery"]) {
								pageInfo {
									endCursor
									hasNextPage
								}
								edges {
									node {
										sprintId
										name
										noSprint
										timeRegTotals {
											totalCost
											totalPrice
											totalTimeRegistered
											totalBillableRegistered
											totalNonBillableRegistered
										}
									}
								}
							}
						}
					}
				`,
			},
			graphql`
				query TimeRegSprintRelayWrapperRefetchQuery(
					$pageSize: Int
					$searchQuery: TaskSearchQueryType
					$reportId: String
					$sharedId: String
				) {
					viewer {
						...TimeRegSprintRelayWrapper_viewer
							@arguments(pageSize: $pageSize, searchQuery: $searchQuery, reportId: $reportId, sharedId: $sharedId)
					}
				}
			`
		)
	)
);
